<template>
	<div class="boton" @click.stop.prevent="toggle">
		<img :src="icono" alt>
	</div>
</template>

<script>
export default {
	computed: {
		icono() {
			if (this.soundEnabled) {
				return require("@/assets/img/sound-on.svg");
			} else {
				return require("@/assets/img/sound-off.svg");
			}
		},
		soundEnabled() {
			return this.$store.getters.soundState;
		}
	},
	methods: {
		toggle() {
			this.$globalEvent.$emit("toggleSound");
		}
	}
};
</script>
<style lang="scss" scoped>
.boton {
	// position: absolute;
	opacity: 0.6;
	background-color: rgba(255, 255, 255, 0.5);
	position: absolute;
	z-index: 8;
	top: 70px;
	right: 10px;
	width: 40px;
	height: 40px;
	border-radius: 40px;
	cursor: url("~@/assets/img/cursors/pointer.png"), pointer;
}
.boton:hover{
    opacity: 1;
}
.boton > img {
	max-width: 40px;
	max-height: 40px;
}
</style>

